import { createLabeledMessages } from '../../../messageUtils';
const generic = {
    genericErrorHeading: 'Prišlo k neznámej chybe',
    fullErrorMessage: 'Úplný výpis chýb',
    copyError: 'Skopírovať údaje pre HelpDesk',
    detailError: 'Zobraziť detail o chybe',
    copyAllErrors: 'Skopírovať údaje o všetkých chybách',
    showFullError: 'Zobraziť úplný výpis chyby',
    hideFullError: 'Skryť úplný výpis chyby',
    overviewOfErrors: 'Úplný prehľad chýb',
    uniqueIdentifier: 'Jednoznačný identifikátor chyby',
    errorDescription: 'Popis chyby',
    closeError: 'Zavrieť chybu',
    noVisibleErrors: 'Nie sú viditeľné žiadne chyby',
    sendError: 'Odoslať záznam o chybe na HD',
    sendAllErrors: 'Odoslať všetky chyby',
    errorSent: 'Hlásenie o chybe úspešne odoslané',
    errorNotSent: 'Neúspešné odoslanie',
    configJsonErrorHeading: 'chyba konfigurácie',
    configJsonErrorDescription: 'pri načítaní konfigurácie aplikácie došlo k chybe',
    invalidRefreshLogoutHeading: 'Neplatný token',
    invalidRefreshLogoutDescription: 'Token na obnovenie sa už nemôže používať. Ak sa chcete znova prihlásiť, kliknite na tlačidlo "Odhlásiť".',
    brokenSessionLogoutHeading: 'Prerušená relácia',
    brokenSessionLogoutDescription: 'Tvoja relácia je neplatná. Ak sa chcete znova prihlásiť, kliknite na tlačidlo "Odhlásiť".".',
    genericLogoutHeading: 'Prihlásenie sa nepodarilo',
    genericLogoutDescription: 'NPri pokuse o prihlásenie došlo k chybe. Ak sa chcete znova prihlásiť, kliknite na tlačidlo "Odhlásiť".',
    loadCduErrorHeading: 'Nepodarilo sa načítať užívateľa z CDU',
    loadCduShortDescription: 'Prosím kontaktujte helpdesk a odhláste sa.',
    hideError: 'Skryť chybu',
    hideAll: 'Skryť všetko',
    showAll: 'Ukázať všetko',
    publicHeading: 'Online to nepôjde',
    publicCommonDescription: 'Opakujte prosím akciu neskôr alebo nás kontaktujte na telefónnom čísle',
    publicKC: '241 114 114'
};
const messages = Object.assign({}, generic);
export default Object.assign({}, messages, createLabeledMessages(messages));
